import Link from 'next/link';
import { useRouter } from 'next/router';
import { useSnackbar } from 'notistack';
import type { FC } from 'react';
import { useEffect } from 'react';
import { Button } from '@/DesignSystem/Component';
import { useLoggedIn } from '@/Module/Auth/Hook';
import { LINKS } from '@/Module/Core/Constant';
import { IconFlag } from '@/Module/Icon';
import { getBookMarkLessonByIdAction } from '@/Module/Lesson/Store/Action';
import { setCanReportAction } from '@/Module/Lesson/Store/Slice/LessonSectionSlice';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const LessonDetailCrashReportButton: FC = () => {
  const {
    enqueueSnackbar
  } = useSnackbar();
  const router = useRouter();
  const loggedIn = useLoggedIn();
  const canReport = useAppSelector(state => state.lessonSection.canReport);
  const lessonSectionSelected = useAppSelector(state => state.lessonSection.selectedLessonSectionId)!;
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!lessonSectionSelected || !loggedIn) return;
    dispatch(getBookMarkLessonByIdAction(lessonSectionSelected));
  }, [lessonSectionSelected, loggedIn]);
  const onClick = () => {
    if (!loggedIn) {
      enqueueSnackbar({
        variant: 'warning',
        message: 'لطفا لاگین بفرمائید',
        className: 'like--Login',
        action: <Button as={Link} href={`${LINKS.AUTH.LOGIN}?redirectUrl=${encodeURI(router.asPath)}`} variant="text" color="primary" className="mr-4 " size="small" bold>
            ورود
          </Button>
      });
      return;
    }
    dispatch(setCanReportAction(!canReport));
  };
  return <Button variant="contained" color="orangeLight" iconButton onClick={onClick} data-sentry-element="Button" data-sentry-component="LessonDetailCrashReportButton" data-sentry-source-file="LessonDetailCrashReportButton.tsx">
      <IconFlag data-sentry-element="IconFlag" data-sentry-source-file="LessonDetailCrashReportButton.tsx" />
    </Button>;
};
export default LessonDetailCrashReportButton;